import { useTranslation } from "react-i18next";
import { ReactComponent as LockIcon } from "../../../assets/svg/lock.svg";
import styles from "./AccessDenied.module.css";

export default function AccessDeniedError() {
  const { t } = useTranslation();
  return (
    <div className={styles.ErrorContainer}>
      <LockIcon className={styles.LockIcon} />
      <h4>{t("access_denied.title")}</h4>
      <p>{t("access_denied.description")}</p>
    </div>
  );
}
